export const APPLICATION_TVA_TYPE_NORMAL = 'Normal';
export const APPLICATION_TVA_TYPE_EXPORT_HORS_UE = 'ExportHorsUE';
export const APPLICATION_TVA_TYPE_INTRACOMMUNAUTAIRE = 'Intracommunautaire';
export const APPLICATION_TVA_TYPE_NON_APPLICABLE = 'NonApplicable';

const LISTE_APPLICATION_TVA = [
  { code: APPLICATION_TVA_TYPE_NORMAL, libelle: 'applicationTVAType.normal' },
  { code: APPLICATION_TVA_TYPE_EXPORT_HORS_UE, libelle: 'applicationTVAType.exportHorsUE' },
  { code: APPLICATION_TVA_TYPE_INTRACOMMUNAUTAIRE, libelle: 'applicationTVAType.intracommunautaire' },
  { code: APPLICATION_TVA_TYPE_NON_APPLICABLE, libelle: 'applicationTVAType.nonApplicable' },
];

export default LISTE_APPLICATION_TVA;
